/*
 * Authors: Triadi, mariushirjanu
 * Created: 31/01/2020
 * Created: 14/09/2022
 */
import { Component, Input } from '@angular/core';
import { ICustomerPermissionExtended } from '../../../shared/user/user-data.service';

@Component({
  selector: 'customer-permissions',
  template: `
    <div *ngIf="customerPermissions">
      <h4 class="form-title">
        <span translate>APP.USER_PROFILE.HEADINGS.ORDER_PERMISSIONS</span> / <span translate>APP.USER_PROFILE.HEADINGS.QUOTE_PERMISSIONS</span>
      </h4>
  
      <p class="bold" translate>APP.USER_PROFILE.PERMISSIONS.HAVE_PERMISSION_ON</p>
  
      <table class="table customer-permissions-table">
  
        <tbody>
          <tr *ngIf="customerPermissions.webshops.length">
            <td>
              <span translate>GA.GENERAL.WEBSHOPS</span>:
            </td>
            <td>
              <span *ngFor="let webshop of customerPermissions.webshops; let last = last; trackById">{{webshop.name}}{{!last ? ', &nbsp;' : ''}}</span>
            </td>
          </tr>
          <tr *ngIf="customerPermissions.regions?.length">
            <td>
              <span translate>GA.GENERAL.REGIONS</span>:
            </td>
            <td>
              <span *ngFor="let region of customerPermissions.regions; let last = last; trackById">{{region.name}}{{!last ? ', &nbsp;' : ''}}</span>
            </td>
          </tr>
          <tr *ngIf="customerPermissions.countries?.length">
            <td>
              <span translate>GA.GENERAL.COUNTRIES</span>:
            </td>
            <td>
              <span *ngFor="let country of customerPermissions.countries; let last = last; trackById">{{country.name}}{{!last ? ', &nbsp;' : ''}}</span>
            </td>
          </tr>
          <tr *ngIf="customerPermissions.subCompanies?.length">
            <td>
              <span translate>GA.GENERAL.SUBCOMPANIES</span>:
            </td>
            <td>
              <span *ngFor="let subCompany of customerPermissions.subCompanies; let last = last; trackById">{{subCompany.name}}{{!last ? ', &nbsp;' : ''}}</span>
            </td>
          </tr>
  
        </tbody>
      </table>
  
      <p *ngIf="customerPermissions.canPlaceText" class="bold">{{customerPermissions.canPlaceText}}</p>
      <p *ngIf="customerPermissions.canViewOthersText" class="bold">{{customerPermissions.canViewOthersText}}</p>
      <p *ngIf="customerPermissions.canViewOwnText" class="bold">{{customerPermissions.canViewOwnText}}</p>
    </div>
  `
})
export class CustomerPermissionsComponent {
  @Input() public customerPermissions:ICustomerPermissionExtended;

  constructor() {
    /***/
  }
}